import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { get, put } from '../api/client.js';

export function useSettings() {
  return useQuery({
    queryKey: ['admin', 'settings'],
    queryFn: () => get('/api/admin/settings'),
    staleTime: 60_000,
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (partial) => put('/api/admin/settings', { settings: partial }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'settings'] }),
  });
}
